import { Box, Typography, Container, Link } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/common/Header";
import MandateSuccessAnimation from "../components/Lottie/MandateSuccessAnimation";
import ErrorAnimation from "../components/Lottie/ErrorAnimation";
import { useLocation } from "react-router-dom";
import SubmitButton from "../components/common/SubmitButton";
import styles from "../Style/Modules/pfPaymentSuccess.module.css";
import "../Style/Theme/index.css";

export default function PFPaymentSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const [disabled] = useState(!location.state.Status);
  let IsLimitEnhacement_Reduction_Final_Check_On_PFSucess =
    location?.state?.IsLimitEnhacement_Reduction_PFSucess;
  let handleSubmit = async (e) => {
    e.preventDefault();
    if (IsLimitEnhacement_Reduction_Final_Check_On_PFSucess === "Enhancement") {
      let data = {
        AppId: location?.state.AppId,
      };
      navigate("/new-approved-limit", { state: data });
    } else {
      let data = {
        AppId: location.state.AppId,
      };
      navigate("/BankDetails", { state: data });
    }
  };
  let handleRetry = async (e) => {
    e.preventDefault();
    let data = { AppId: location.state.AppId, Amt: location.state.Amt };
    navigate("/pfpayment", { state: data });
  };

  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Header showBar={true} step={16} />
        <Box sx={{ paddingBottom: "100px" }}>
          {location.state.paymentstatus === "Paid" ? (
            <Box className={styles.pFPaymentSuccessBox}>
              <Typography variant="h2" className={styles.pFPaymentSuccessTypo}>
                Payment Successful
              </Typography>
              <MandateSuccessAnimation />
              <label className="subTitle_Th">
                <b>Reference ID:</b>
                {location.state.referenceno}
              </label>
              <label className="subTitle_Th">
                <b>Amount:</b>
                {location.state.amount}
              </label>
              <label className="subTitle_Th">
                <b>Paid Amount:</b>
                {location.state.paidamount}
              </label>
              <label className="subTitle_Th">
                <b>Payment Status:</b>
                {location.state.paymentstatus}
              </label>{" "}
            </Box>
          ) : (
            <Box className={styles.pFPaymentSuccessBox}>
              {" "}
              <Typography variant="h2" className={styles.pFPaymentSuccessTypo}>
                Payment Unsuccessful
                <br />
                <br />
              </Typography>
              <ErrorAnimation />
              <label>
                {" "}
                Please check your sms or email for payment link or contact our
                support team.
              </label>
              <br />
              <label className="subTitle_Th">
                <b>Reference ID: </b>
                {location.state.referenceno}
              </label>
              <label className="subTitle_Th">
                <b>Amount:</b>
                {location.state.amount}
              </label>
              <label className="subTitle_Th">
                <b>Paid Amount: </b>
                {location.state.paidamount}
              </label>
              <label className="subTitle_Th">
                <b>Payment Status: </b>
                {location.state.paymentstatus}
              </label>
            </Box>
          )}
          {location.state.paymentstatus !== "paid" && (
            <Box className={styles.pFPaymentSuccessBox1}>
              {/* <Link onClick={handleRetry}>
                <Typography
                  variant="p"
                  color="info"
                  sx={{ fontWeight: "500", ml: 1 }}
                >
                  Retry
                </Typography>
              </Link> */}
            </Box>
          )}
        </Box>
        <form onSubmit={handleSubmit}>
          <SubmitButton hasNote="No" disabled={disabled} />
        </form>
      </Container>
    </>
  );
}
